<template>
<div class="pa-3 full-width">
<div class="chart-heading mb-2 ml-1">{{chart.name}}</div> 
<p v-if="!chart.columns">No Columns</p>
<table class="chart-outline">
    <tr>
        <td></td>
        <td v-for="column in chart.columns" class="chart-column">
            <div class="chart-header">
                {{column.title}}
            </div>
        </td>    
    </tr>
    <tr v-for="transaction in transactions" class="chart-row">

        <td style="background-color:#ccc;width:8px;padding:0;"></td>
    
        <td v-for="column in chart.columns" class="chart-column">
            <div class="chart-cell">
                <a :href="transactionLink(transaction.meta.key)" target="_blank" class="transparent">
                <ChartControl :record="transaction" :definition="column" />
                </a>

            </div>
        </td>
    </tr>
</table>    
</div>
</template>

<script>
import DataHelpers from '../../helpers/DataHelpers'
import NiceData from '../../data/NiceData'
import ChartControl from './ChartControl'
import { subMonths } from 'date-fns/esm/fp'
import DateHelpers from '../../helpers/DateHelpers'

export default {
name: 'ProgressChart',
props: {
    tenantKey: String,
    chart: Object
},
components: {
    ChartControl
},

data() {
return {
    transactions: []
}
},
computed:{


},
methods: {
    loadChartData() {
        const threeMonthsAgo = subMonths(3, new Date())
        const threeMonthsAgoStr = DateHelpers.dateToBackwards(threeMonthsAgo)
        let ref = DataHelpers.getTenantRef(this.tenantKey).child('milestones')
        console.log('trigger start is', this.chart.triggerStart)
        if(this.chart.triggerStart)
            ref = ref.orderByChild(this.chart.triggerStart + '_date').startAt(threeMonthsAgoStr).limitToLast(100)
        ref.on('value', snap => {
            const transactions = Array.reverse(NiceData.arrayFromSnapshot(snap))
            // debugger
            this.transactions = transactions
        })
    },
    transactionLink(transactionKey) {
        return '/' + this.tenantKey + '/transaction/' + transactionKey
    }
},
created() {
    this.loadChartData()
},
watch: {
    chart: {
        immediate: true,
        handler: function (newVal) {
            this.loadChartData()
        }
    }
}
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  
    .chart-outline {
        min-width:100%;
        margin-top:-35px;
    }
    .chart-header {
        width:100%;font-weight: bold; padding:10px;
        color:#888; height:35px;
    }
    .chart-row {
        width:100%;
    }
    .chart-column {
        padding:1px; flex-grow: 1;
    }
    
    .chart-cell {
        /* background-color: #eee; */
        height:60px;
    }
    .chart-heading {
        font-size:28px;
        color:rgb(5, 116, 150);
    }

</style>


// WEBPACK FOOTER //
// ProgressChart.vue?51b3a2a2